import type { App } from "vue";

import { CBridge } from "./cBirdge";
import { CButton } from "./cButton";
import { CForm } from "./cForm";
import { CInput } from "./cInput";
import { CInputNumber } from "./cInputNumber";
import { CModal } from "./cModal";
import { CPagination } from "./cPagination";
import { CSelect ,CSelectOption} from "./cSelect";
import { CTable } from "./cTable";
import { CTabs, CTabPane } from "./cTabs";
import { CUpload } from "./cUpload";
import { CRadioGroup } from "./cRadio";
import { Checkbox, CheckboxGroup } from "./cCheckbox";
import { CalendarPicker } from "./calendarPicker";
import { FugleTable } from "./FugleTable";
import { Validator } from "./validator";
import { CDivider } from "./cDivider";
// 2026-08-26：订单详情统一复用可编辑的备注/留言组件。
import { OrderCommentEditor } from "./orderCommentEditor";
// 2026-09-17：商品和订单列表共用六字全文提示及订单复制组件。
import ListText from './ListText.vue'
import CompactOrderTable from './CompactOrderTable.vue'
// 所有组件列表
const components = [
  ListText, CompactOrderTable,
  CBridge,
  CButton,
  Validator,
  FugleTable,
  CForm,
  CInput,
  CInputNumber,
  CModal,
  CPagination,
  CSelect,
  CSelectOption,
  CTable,
  CTabs,
  CTabPane,
  CUpload,
  CRadioGroup,
  Checkbox,
  CheckboxGroup,
  CalendarPicker,
  CDivider,
  OrderCommentEditor
]

export default {
  install: (app: App) => {
    components.forEach(component => app.component(component.name, component))
  }
}
